import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import HistoryDateFilter from "./HistoryDateFilter";
import ShowQuestionModal from "../../../Home/Tracks/ExamView/ShowQuestionModal";
import QuestionView from "../../Question/View/QuestionView";

import "../../QuestionView/QuestionView.css";

const UserErrorReportsModal = ({ show, onClose, user, t, userSwitcher }) => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [startDate, setStartDate] = useState(moment().subtract(6, 'days'));
    const [endDate, setEndDate] = useState(moment());
    const [searchText, setSearchText] = useState("");
    const [searchMode, setSearchMode] = useState("date");
    const [count, setCount] = useState(20);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [showQuestionModal, setShowQuestionModal] = useState(false);

    const fetchData = (currentMode = searchMode, start = startDate, end = endDate, cnt = count) => {
        if (!user) return;
        setLoading(true);

        let url = "";
        if (currentMode === "date") {
            url = `/ErrorReport/?userId=${user.Id}&startDate=${start.format('DD/MM/YYYY')}&endDate=${end.format('DD/MM/YYYY')}&count=1000&searchMode=date`;
        } else {
            url = `/ErrorReport/?userId=${user.Id}&count=${cnt}&searchMode=count`;
        }

        api.get(url)
            .then(resp => {
                setReports(resp.data?.data || []);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        if (show && user) {
            fetchData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show, user]);


    const filteredReports = reports.filter(report => {
        if (searchMode === "date") {
            const msgDate = moment(report.CreationDate, "YYYY-MM-DD HH:mm");
            const isWithinDate = msgDate.isBetween(startDate.clone().startOf('day'), endDate.clone().endOf('day'), null, '[]');
            if (!isWithinDate) return false;
        }

        if (!searchText) return true;
        const text = searchText.toLowerCase();
        return (
            (report.Name && report.Name.toLowerCase().includes(text)) ||
            (report.Note && report.Note.toLowerCase().includes(text)) ||
            (report.Question && report.Question.Name && report.Question.Name.toLowerCase().includes(text))
        );
    });

    return (
        <>
            <Modal size="lg" centered show={show} onHide={onClose} className="admin-history-modal" enforceFocus={false}>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="w-100">
                        <div className="d-flex align-items-center">
                            <div className="history-modal-icon-wrapper ml-3 text-danger">
                                <i className="fad fa-bug"></i>
                            </div>
                            <div className="text-right">
                                <div className="h5 mb-1 font-weight-bold text-dark">{t("Pages.UsersControl.action.errorReports") || "بلاغات الأخطاء"}</div>
                                {userSwitcher || <div className="small text-muted">{user?.Name}</div>}
                            </div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-4 pb-4">
                    <HistoryDateFilter
                        startDate={startDate}
                        endDate={endDate}
                        searchMode={searchMode}
                        count={count}
                        searchText={searchText}
                        showSearchModeSelect={true}
                        onApply={(mode, start, end, cnt, search) => {
                            setSearchMode(mode);
                            setStartDate(start);
                            setEndDate(end);
                            setCount(cnt);
                            setSearchText(search);
                            fetchData(mode, start, end, cnt);
                        }}
                        t={t}
                    />

                    {loading ? (
                        <div className="text-center py-5">
                            <i className="fad fa-sync fa-spin fa-2x text-muted mb-2"></i>
                            <div className="text-muted small">{t("Pages.UsersControl.Loading") || "جاري التحميل..."}</div>
                        </div>
                    ) : filteredReports.length === 0 ? (
                        <div className="text-center py-5 text-muted">
                            <i className="fal fa-file-search fa-2x mb-2 d-block"></i>
                            <span>{t("Pages.UsersControl.NotFound") || "لا توجد نتائج"}</span>
                        </div>
                    ) : (
                        <div className="history-modal-list scrollbar-custom mx-0" style={{ direction: 'rtl' }}>
                            {filteredReports.map((report, index) => (
                                <div key={report.Id} className="question-card-premium mb-3 w-100 text-right">
                                    <div className="question-card-inner-flex align-items-start">
                                        <div className="question-badge-index" style={{ background: '#fef2f2', color: '#dc2626' }}>
                                            <span>{index + 1}</span>
                                        </div>
                                        <div className="question-card-content w-100">
                                            <div className="d-flex align-items-center justify-content-between w-100 mb-3 flex-wrap gap-2">
                                                <h6 className="compact-history-title mb-0 font-weight-bold text-dark d-flex align-items-center flex-wrap">
                                                    {report.Index && (
                                                        <span className="text-muted small ml-1">{report.Index.Name} &gt; </span>
                                                    )}
                                                    <Link
                                                        to={`/ControlPanel/Lesson/Edit/${report.LessonId}`}
                                                        className="text-primary text-decoration-none hover-underline d-inline-flex align-items-center font-weight-bold"
                                                        style={{ fontSize: '1rem' }}
                                                    >
                                                        <i className="fad fa-chalkboard-teacher ml-1 text-primary" style={{ fontSize: '0.95rem' }}></i>
                                                        <span>{report.Name}</span>
                                                        <i className="fal fa-external-link-alt mr-1 text-muted" style={{ fontSize: '0.75rem' }}></i>
                                                    </Link>
                                                </h6>
                                                <div className="d-flex align-items-center gap-2">
                                                    <span className={`compact-history-badge ${report.IsSolved ? "green" : "red"}`}>
                                                        <i className={`fal ${report.IsSolved ? "fa-check-circle" : "fa-exclamation-circle"} ml-1`}></i>
                                                        {report.IsSolved ? t("Pages.UsersControl.errorReports.Solved") : t("Pages.UsersControl.errorReports.Active")}
                                                    </span>
                                                    {report.IsArchived && (
                                                        <span className="compact-history-badge secondary">
                                                            <i className="fal fa-archive ml-1"></i>
                                                            {t("Pages.UsersControl.errorReports.Archived")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="w-100 pr-3 pl-3 py-3 mb-3 bg-light rounded text-right" style={{ borderRight: '4px solid #f43f5e', background: '#fffafb' }}>
                                                <div className="small text-danger font-weight-bold mb-1">{t("Pages.UsersControl.errorReports.Note")}:</div>
                                                <div
                                                    className="mb-0 text-dark font-weight-bold"
                                                    style={{ whiteSpace: 'pre-line', fontSize: '0.95rem', lineHeight: '1.6' }}
                                                    dangerouslySetInnerHTML={{ __html: report.Note }}
                                                />
                                            </div>

                                            <div className="question-card-footer-premium d-flex flex-wrap gap-2 mt-3 align-items-center w-100 border-top pt-2">
                                                {report.Question && (
                                                    <div className="d-inline-flex flex-wrap gap-2 align-items-center">
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 text-decoration-none px-3"
                                                            style={{ borderRadius: '8px', fontWeight: '600' }}
                                                            onClick={() => {
                                                                setSelectedQuestion(report.Question);
                                                                setShowQuestionModal(true);
                                                            }}
                                                        >
                                                            <i className="fal fa-eye ml-1"></i>
                                                            <span>{t("Pages.UsersControl.errorReports.PreviewQuestion")}</span>
                                                        </button>
                                                        <span className="text-secondary mr-2" style={{ fontSize: '0.85rem' }}>
                                                            <i className="fal fa-question-circle ml-1 text-info"></i>
                                                            {t("Pages.UsersControl.errorReports.QuestionName")}: <b dangerouslySetInnerHTML={{ __html: report.Question.Name }} />
                                                        </span>
                                                    </div>
                                                )}
                                                <div className="mr-auto d-flex align-items-center text-muted small">
                                                    <span className="badge badge-light p-2">
                                                        <i className="fal fa-calendar-alt ml-1"></i>
                                                        {report.CreationDate}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer className="border-0 pt-0 text-center justify-content-center">
                    <button type="button" className="btn btn-light px-5 py-2" style={{ borderRadius: '10px', fontWeight: '600' }} onClick={onClose}>
                        {t("Close") || "إغلاق"}
                    </button>
                </Modal.Footer>
            </Modal>

            {showQuestionModal && selectedQuestion && (
                <ShowQuestionModal
                    showResult={true}
                    handleClose={() => {
                        setShowQuestionModal(false);
                        setSelectedQuestion(null);
                    }}
                    renderQuestionView={() => (
                        <QuestionView
                            question={selectedQuestion}
                            key={selectedQuestion.Id}
                            index={1}
                            showResult={false}
                            onEdit={true}
                            solveButton={false}
                        />
                    )}
                />
            )}
        </>
    );
};

export default UserErrorReportsModal;
